import React from 'react'

const plugin = () => ({
  schema: {
    nodes: {
      // can't actually render null as slate expects elements to exist in DOM
      null: () => <span />,
    },
  },
})

export { plugin as NullRenderPlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/NullRender.js